import React, { useContext, useState } from 'react';
import { withRouter, matchPath } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import Navbar from '@uniiverse/library/components/navbar';
import Footer from '@uniiverse/library/components/footer';
import LocaleContext from 'context/locale-context';
import { OrganizationContext } from '../../../components/organization-select/withOrganization';
import { LOCALES, localesNavBar } from '../../../../src/lib/locale';
import AddOnsCreateEditForm from '../../../components/add-ons/create-edit';
import { locale } from './locale.js';
import styles from './styles-module.css';
import ChevronLeft from '../../../assets/add-ons/chevron_left.svg';
import CancelModal from '../CancelModal';
import './index.css';

const AddOnsCreate = injectIntl((props) => {
  const [cancelModalOpen, setCancelModalOpen] = useState(false);
  const localeContext = useContext(LocaleContext);
  const { user } = localeContext;
  const editPageMatch = matchPath(props.location.pathname, {
    path: '/dashboard/add-ons/edit/:id',
    exact: true,
    strict: false
  });
  const { selectedUser } = useContext(OrganizationContext);

  const headerTitle = !editPageMatch
    ? props.intl.formatMessage(locale.createPageTitle)
    : props.intl.formatMessage(locale.editPageTitle);

  return <>
    <main>
      <Navbar
        user={localeContext.user}
        locales={localesNavBar}
        switchLocale={localeContext.switchLocale}
      />
      <section className={styles.addOns}>
        <CancelModal 
          cancelModalOpen={cancelModalOpen}
          setCancelModalOpen={setCancelModalOpen}
          history={props.history}
        />
        <div className={styles.backToInventory} onClick={() => setCancelModalOpen(true)} role="button" tabIndex={0}>
          <ChevronLeft /> {props.intl.formatMessage(locale.backToInventory)}
        </div>
        <AddOnsCreateEditForm
          intl={props.intl}
          addOnId={editPageMatch ? editPageMatch.params.id : null}
          headerTitle={headerTitle}
          user={user}
          hostId={selectedUser.id}
          setCancelModalOpen={setCancelModalOpen}
          {...props}
        />
      </section>
      <Footer
        switchLocale={localeContext.switchLocale}
        locale={localeContext.locale}
        locales={LOCALES}
      />
    </main>
  </>
});

export default injectIntl(withRouter(AddOnsCreate));
